import type { ComponentPropsWithoutRef } from 'react';

import { cn } from '../../lib/utils';
import { Icon } from '../icon';

type AvatarChipProps = ComponentPropsWithoutRef<'span'> & {
  name: string;
  /**
   * Selects the leading icon. `'user'` (default) shows a single-person icon
   * for individual users; `'group'` shows a multi-person icon for user groups.
   */
  variant?: 'user' | 'group';
};

export const AvatarChip = ({
  className,
  name,
  variant = 'user',
  ...props
}: AvatarChipProps) => (
  <span
    data-slot={'avatar-chip'}
    className={cn(
      'inline-flex items-center gap-2 min-w-0',
      'rounded-full bg-neutral-hover px-3 py-1.5',
      'text-xs font-semibold text-primary-hover',
      className
    )}
    title={name}
    {...props}
  >
    <Icon
      name={variant === 'group' ? 'users-01' : 'user-01'}
      size={'xs'}
      className={cn('shrink-0')}
    />
    <span className={cn('truncate')}>{name}</span>
  </span>
);
